define('lmbAnalyzerCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!lmbAnalyzerCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'settings',
  'autocompleteView'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  Settings,
  AutocompleteView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
      selectMbAModel: '.js-select-mbamodel-region'
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    initialize: function(options) {
      this.model = options.lmbAnalyzerModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();

      var mbAModelView = new AutocompleteView(
          this._getMbAModelsAutocompleteOptions('refMbAModel')
      );
      this.getRegion('selectMbAModel').show(mbAModelView);

      this.triggerMethod('enable:cancel:confirm');
    },

    _getMbAModelsAutocompleteOptions: function(property) {
      var mbAModel = this.model.get(property);
      return {
        type: 'remote',
        remote: Settings.url('compuzz', 'v2/mbamodels'),
        valueKey: 'code',
        apiKey: 'secId',
        placeholder: _.i18n('selectmbamodel.placeholder'),
        value: mbAModel ? mbAModel.code : null,
        name: property,
        onPressKey: true,
        lazyLoad: true,
        keys: {
          query: 'code',
          limit: 'pageSize'
        },
        callback: _.bind(this.onChangeMbAModel, this)
      };
    },

    onChangeMbAModel: function(fieldName, model) {
      if (model) {
        model.unset('autocompleteValue', {silent: true});
      }
      this.onChange(fieldName, model);
      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.options.lmbAnalyzerModel.set(modelJSON);
      this.triggerMethod('saved');
      App.trigger('lmbanalyzer:header:rerender', modelJSON);
      App.navigate('admin/lmbanalyzers/' + model.get('secId'), {trigger: true});
      this.hide();
    },

    hide: function() {
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (App.getCurrentRoute() ===  'admin/lmbanalyzers/new') {
        App.navigate('admin/lmbanalyzers', {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    }
  });

  module.exports = CreateEditLayoutView;
});
